import { longArray288a0fctlmjmj as longArray } from '../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_lastIndex1y2f6o9u8hnf7 as get_lastIndex } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Arrays.mjs';
import { shiftLeft3tsh2sstjchzn as shiftLeft } from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { countTrailingZeroBits1k55x07cygoff as countTrailingZeroBits } from '../../../../kotlin-kotlin-stdlib/kotlin/NumbersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.n19_1 = longArray(0);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function prepareHighMarksArray($this, elementsCount) {
  var slotsCount = (elementsCount - 1 | 0) >>> 6 | 0;
  var elementsInLastSlot = elementsCount & 63;
  var highMarks = longArray(slotsCount);
  if (!(elementsInLastSlot === 0)) {
    highMarks[get_lastIndex(highMarks)] = shiftLeft(-1n, elementsCount);
  }
  return highMarks;
}
function markHigh($this, index) {
  var slot = (index >>> 6 | 0) - 1 | 0;
  var offsetInSlot = index & 63;
  $this.r19_1[slot] = $this.r19_1[slot] | shiftLeft(1n, offsetInSlot);
}
function nextUnmarkedHighIndex($this) {
  var inductionVariable = 0;
  var last = $this.r19_1.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var slot = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var slotOffset = imul(slot + 1 | 0, 64);
      var slotMarks = $this.r19_1[slot];
      while (!(slotMarks === -1n)) {
        var indexInSlot = countTrailingZeroBits(~slotMarks);
        slotMarks = slotMarks | shiftLeft(1n, indexInSlot);
        var index = slotOffset + indexInSlot | 0;
        if ($this.p19_1($this.o19_1, index)) {
          $this.r19_1[slot] = slotMarks;
          return index;
        }
      }
      $this.r19_1[slot] = slotMarks;
    }
     while (inductionVariable <= last);
  return -1;
}
var ElementMarkerClass;
function ElementMarker() {
  if (ElementMarkerClass === VOID) {
    class $ {
      constructor(descriptor, readIfAbsent) {
        Companion_getInstance();
        this.o19_1 = descriptor;
        this.p19_1 = readIfAbsent;
        var elementsCount = this.o19_1.u11();
        if (elementsCount <= 64) {
          var tmp = this;
          var tmp_0;
          if (elementsCount === 64) {
            tmp_0 = 0n;
          } else {
            tmp_0 = shiftLeft(-1n, elementsCount);
          }
          tmp.q19_1 = tmp_0;
          this.r19_1 = Companion_getInstance().n19_1;
        } else {
          this.q19_1 = 0n;
          this.r19_1 = prepareHighMarksArray(this, elementsCount);
        }
      }
      s19(index) {
        if (index < 64) {
          this.q19_1 = this.q19_1 | shiftLeft(1n, index);
        } else {
          markHigh(this, index);
        }
      }
      t19() {
        var elementsCount = this.o19_1.u11();
        while (!(this.q19_1 === -1n)) {
          var index = countTrailingZeroBits(~this.q19_1);
          this.q19_1 = this.q19_1 | shiftLeft(1n, index);
          if (this.p19_1(this.o19_1, index)) {
            return index;
          }
        }
        if (elementsCount > 64) {
          return nextUnmarkedHighIndex(this);
        }
        return -1;
      }
    }
    initMetadataForClass($, 'ElementMarker');
    ElementMarkerClass = $;
  }
  return ElementMarkerClass;
}
//region block: exports
export {
  ElementMarker as ElementMarker33ojvsajwmzts,
};
//endregion

//# sourceMappingURL=ElementMarker.mjs.map
